<ng-container *t="let t" [formGroup]="bankSecurityForm">
  <div class="main-container">
    <h3 class="tab-header" mat-dialog-title i18n="@@8189103629267763429" t="8189103629267763429">Add or Change Bank
      Information</h3>
    <div class="form-header" i18n="@@securityCheckDescription" t="securityCheckDescription"> In order to manage your
      bank information on file with Tesla, please answer the below questions for security validation purposes.
    </div>
    <div class="content-container">
      <div class="form-container" fxLayout="row" *ngIf="attempts?.wrongAttempts >= 1 || profileEvent?.correlationId">
        <div fxFlex="10">
        </div>
        <div class="warning-details" fxFlex="80">
          <div style="display: flex;">
            <tsl-icon style="color: #FBB01B; margin:10px;">warning</tsl-icon>
            <div i18n="@@securityCheckWarningDescription" t="securityCheckWarningDescription"> Please make sure the
              information you provide below is correct. If you have any further questions, please reach out to: </div>
          </div>
          <div style="padding-left: 55px;">
            <span i18n="@@9097415673098704514" t="9097415673098704514" style="font-weight: bold;">
                Tesla Supplier onboarding and data inquiries
            </span>
            <br />
            <span i18n="@@contactVendorChanges" t="contactVendorChanges">
                Contact the Vendor Changes Team at the following resources:
            </span>
            <br />
            <ul>
                <li>
                    <span i18n="@@globalTeamRegions" t="globalTeamRegions">
                        EMEA/NA/SA:
                    </span>
                    <a class="link" i18n="@@HomeTabHelpNewEmail" t="HomeTabHelpNewEmail" href="mailto:Vendorchanges@tesla.com">
                        Tesla Vendor Changes Team
                    </a>
                </li>
                <li>
                    <span i18n="@@apacTeamRegions" t="apacTeamRegions">
                        APAC/CN:
                    </span>
                    <a class="link" i18n="@@VendorchangesapacEmail" t="VendorchangesapacEmail" href="mailto:Vendorchangesapac@tesla.com">
                        Tesla Vendor Changes APAC Team
                    </a>
                </li>
            </ul>
        </div>
        </div>
      </div>
      <div class="form-container">
        <div *ngIf="profileEvent">
          <p i18n="@@d106826fbee9f9e017fe78864b10259e1c4f46f9" t="d106826fbee9f9e017fe78864b10259e1c4f46f9">Hello,</p>
          <p>
            <span i18n="@@2306679705138887613" t="2306679705138887613">The changes requested require further
              review/validation. Please email Tesla Vendor Changes Team with this reference number in the subject
              line</span>
            <b>{{profileEvent.correlationId}}</b>.
          </p>
          <p>
            <span i18n="@@61f13ca737ae2e1167a2a88d00e8646be79fc714" t="61f13ca737ae2e1167a2a88d00e8646be79fc714">Thank
              you,</span>
            <br />
            <span i18n="@@a3cfdfeeb008657e4c4bfa91d24fce2a973c3a33" t="a3cfdfeeb008657e4c4bfa91d24fce2a973c3a33">Tesla
              Vendor Changes Team</span>
          </p>
        </div>
        <div class="grid" *ngIf="!profileEvent">
          <div fxLayout="row" *ngIf="errors">
            <div *ngIf="errors.length > 0">
              <ul>
                <li *ngFor="let error of errors" class="error">
                  <div>
                    {{ translateService.get(error) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div fxLayout="row">
            <div fxFlex="70">
              <tsl-label i18n="@@1724336815479793679" t="1724336815479793679">1. Why is your organization requesting to
                make changes to your banking information?
              </tsl-label>
            </div>
          </div>
          <div fxLayout="row">
            <tsl-form-field fxFlex="70">
              <tsl-select triggerIcon="location_on" formControlName="ChangeReason" name="ChangeReason">
                <tsl-option i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                  t="9ca82952a6bc860b5391d5975322d8af8ceddfa4">Select</tsl-option>
                <tsl-option *ngFor="let reason of bankChangeReasons" [value]="reason.Code">{{
                  translateService.get(reason.Name) }}
                </tsl-option>
              </tsl-select>
              <tsl-error *ngIf="hasError(BankSecurityFormControls.ChangeReason)">
                <span>{{getValidationMessages('ChangeReason', 'Reason',BankSecurityFormControls.ChangeReason)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div fxLayout="row">
            <div fxFlex="70">
              <tsl-label i18n="@@5402805230040694307" t="5402805230040694307">2. Please confirm if your organization
                received any payments from Tesla.</tsl-label>
            </div>
          </div>
          <div fxLayout="row">
            <div fxFlex="70">
              <tsl-radio-group formControlName="IsLastPaymentReceived">
                <tsl-radio-button [value]=true><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                <tsl-radio-button [value]=false><span i18n="@@No" t="No">No</span></tsl-radio-button>
              </tsl-radio-group>
            </div>
          </div>
          <div fxLayout="row" *ngIf="BankSecurityFormControls?.IsLastPaymentReceived?.value == true">
            <div fxFlex="70">
              <tsl-label i18n="@@5019985721462972385" t="5019985721462972385">Please confirm the last payment amount
                received.</tsl-label>
            </div>
          </div>
          <div fxLayout="row" *ngIf="BankSecurityFormControls?.IsLastPaymentReceived?.value == true">
            <tsl-form-field fxFlex="25">
              <input type="number" tPlaceholder="6533918067030990396" i18n-placeholder="@@6533918067030990396"
                placeholder="Amount" tslInput fullWidth formControlName="LastPaymentReceived" title="Test title"
                name="txtLastPaymentReceived" />
              <button size="small" tsl-icon-button tslSuffix
                tooltip="Number Format Example: 12,345.67, Please enter the exact amount."
                i18n-tooltip="@@SecurityNumberFormateTooltip" #numberFormatButton
                tslTooltip="{{ t('SecurityNumberFormateTooltip', numberFormatButton) }}">
                <tsl-icon size="small">help</tsl-icon>
              </button>
              <tsl-error *ngIf="hasError(BankSecurityFormControls.LastPaymentReceived)">
                <span>{{getValidationMessages('LastPaymentReceived', null,
                  BankSecurityFormControls.LastPaymentReceived)}}
                </span>
              </tsl-error>
            </tsl-form-field>
            <tsl-form-field fxFlex="45">
              <tsl-select tPlaceholder="Currency" i18n-placeholder="@@Currency" placeholder="Currency"
                triggerIcon="location_on" formControlName="Currency" name="Currency">
                <tsl-option i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                  t="9ca82952a6bc860b5391d5975322d8af8ceddfa4">Select</tsl-option>
                <tsl-option *ngFor="let currency of currencies | sortBy: 'asc' : 'CODE'" [value]="currency.CODE">
                  {{currency.CODE}} - {{ translateService.get(currency.Name)}}</tsl-option>
              </tsl-select>
              <tsl-error *ngIf="hasError(BankSecurityFormControls.Currency)">
                <span>{{getValidationMessages('Currency', 'Currency',BankSecurityFormControls.Currency)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div fxLayout="row">
            <div fxFlex="70">
              <tsl-label i18n="@@7977147957784958922" t="7977147957784958922">3. Please confirm your current Bank
                Account Number/IBAN on file with Tesla.</tsl-label>
            </div>
          </div>
          <div fxLayout="row">
            <tsl-form-field fxFlex="70">
              <input tslInput fullWidth formControlName="AccountNumber" name="txtAccountNumber" />
              <tsl-error *ngIf="hasError(BankSecurityFormControls.AccountNumber)">
                <span>{{getValidationMessages('AccountNumber', 'Account Number',
                  BankSecurityFormControls.AccountNumber)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div fxLayout="row">
            <div fxFlex="100">
              <tsl-label i18n="@@426105087010490288" t="426105087010490288">4. Please list the Beneficiary Name of the
                organization/person receiving payments from
                Tesla.
              </tsl-label>
              <tsl-icon size="small"
                tooltip="The Beneficiary Name is the name of the person or organization receiving the payments. Please confirm with your Finance Department for the correct Beneficiary Name."
                i18n-tooltip="@@SecurityBeneficiaryNameTooltip" #SecurityBeneficiaryNameIcon
                tslTooltip="{{ t('SecurityBeneficiaryNameTooltip', SecurityBeneficiaryNameIcon) }}">help</tsl-icon>
            </div>
          </div>
          <div fxLayout="row">
            <tsl-form-field fxFlex="70">
              <input tslInput fullWidth formControlName="Beneficiary" name="txtBeneficiary" />
              <tsl-error *ngIf="hasError(BankSecurityFormControls.Beneficiary)">
                <span>{{getValidationMessages('Beneficiary', 'Beneficiary Name', BankSecurityFormControls.Beneficiary)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div fxLayout="row">
            <div fxFlex="90">
              <tsl-label i18n="@@2767223050944963889" t="2767223050944963889">5. Please check if your organization's
                Accounts Receivable has been outsourced to a third
                party,
                such as a Factoring Agent. </tsl-label>
            </div>
          </div>
          <div fxLayout="row">
            <div fxFlex="70">
              <tsl-radio-group formControlName="AROutSourced">
                <tsl-radio-button [value]=true><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                <tsl-radio-button [value]=false><span i18n="@@No" t="No">No</span></tsl-radio-button>
              </tsl-radio-group>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="actions right">
      <div *ngIf="showAttempts" class="error attempts">
        <b> {{ showAttemptsMessage }} </b>
      </div>
      <button tsl-button size="small" color="black" outline (click)="onNoClick()"
        i18n="@@d7b35c384aecd25a516200d6921836374613dfe7" t="d7b35c384aecd25a516200d6921836374613dfe7">Cancel</button>
      <button tsl-button size="small" color="blue" filled (click)="submit()" *ngIf="!profileEvent"
        i18n="@@71c77bb8cecdf11ec3eead24dd1ba506573fa9cd" t="71c77bb8cecdf11ec3eead24dd1ba506573fa9cd">Submit</button>
    </div>
  </div>
</ng-container>